import { css } from '@emotion/react';
import { Tooltip } from './tooltip';
import InformationSVG from '@birdi/icons/information-tooltip.svg';
import { TooltipProvider } from '@radix-ui/react-tooltip';

interface InformationIndicatorProps {
  message: React.ReactNode;
}

export const InformationIndicator = ({
  message,
}: InformationIndicatorProps) => {
  return (
    <TooltipProvider>
      <Tooltip
        trigger={
          <div
            css={css`
              display: flex;
              align-items: center;
            `}
            onClick={(e) => e.stopPropagation()}
          >
            {/* @ts-ignore - SVG and CSS prop type error */}
            <InformationSVG data-testid="information-indicator-icon" />
          </div>
        }
      >
        {message}
      </Tooltip>
    </TooltipProvider>
  );
};
